import SEO from "../components/SEO";

const TermsPage = () => {
  return (
    <div className="min-h-screen pt-24 bg-[#FAF9F6]">
      <SEO
        title="Terms of Service"
        description="Terms of Service for Magnus Kor Talent Partners. Terms governing use of our website, tools, and talent advisory services."
        canonical="https://magnuskor.com/terms"
      />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="font-display text-3xl md:text-4xl text-[#1A1A1A] mb-2" data-testid="terms-title">Terms of Service</h1>
        <p className="text-sm text-gray-400 mb-10">Last updated: February 2026</p>

        <div className="prose prose-gray max-w-none space-y-8 text-gray-600 text-[15px] leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">1. Introduction</h2>
            <p>These Terms of Service ("Terms") govern your use of the Magnus Kor Talent Partners website (magnuskor.com) and related services. By accessing or using our website, you agree to be bound by these Terms. Magnus Kor Talent Partners is a trading name of L&D Nexus Limited (Company No. 16450617), registered in England and Wales.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">2. Services</h2>
            <p>Magnus Kor provides talent advisory services for VC-backed SaaS startups, including retained search, contingency hiring, and embedded talent advisory. We also provide free online tools (Salary Calculator, Equity Calculator, Smart Hire Planner) for informational purposes.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">3. Use of Website</h2>
            <p>You agree to use our website only for lawful purposes and in accordance with these Terms. You must not:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Use the website in any way that violates applicable laws or regulations</li>
              <li>Attempt to gain unauthorised access to any part of the website or its systems</li>
              <li>Use automated tools to scrape, crawl, or extract data beyond what is publicly available</li>
              <li>Submit false or misleading information through any form on the website</li>
              <li>Interfere with or disrupt the website or its infrastructure</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">4. Free Tools Disclaimer</h2>
            <p>Our free tools (Salary Calculator, Equity Calculator, Hiring Cost Calculator, Smart Hire Planner) are provided for informational and educational purposes only. The data, calculations, and recommendations are based on aggregated market data and AI-generated analysis. They do not constitute financial, legal, or employment advice. Magnus Kor makes no warranty regarding the accuracy, completeness, or timeliness of tool outputs.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">5. Job Listings</h2>
            <p>Job listings on our website are provided on behalf of our clients. While we strive to keep listings accurate and current, we cannot guarantee that all details are up-to-date. Submitting a job application through our website does not guarantee employment or an interview.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">6. Testimonials</h2>
            <p>Testimonials submitted through our website are subject to review and approval. By submitting a testimonial, you grant Magnus Kor a non-exclusive, royalty-free licence to display your testimonial, name, role, and company name on our website and marketing materials. You may request removal of your testimonial at any time by contacting us.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">7. Intellectual Property</h2>
            <p>All content on this website, including text, graphics, logos, tools, and software, is the property of L&D Nexus Limited or its licensors and is protected by UK and international copyright and intellectual property laws. You may not reproduce, distribute, or create derivative works from our content without written permission.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">8. Client Engagement Terms</h2>
            <p>Specific terms for talent advisory engagements (fees, guarantees, timelines) are governed by separate client agreements. These website Terms do not modify or supersede any signed engagement agreement.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">9. Limitation of Liability</h2>
            <p>To the maximum extent permitted by law, Magnus Kor shall not be liable for any indirect, incidental, consequential, or special damages arising from your use of the website or our services. Our total liability for any claim shall not exceed the fees paid by you (if any) in the 12 months preceding the claim.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">10. Indemnification</h2>
            <p>You agree to indemnify and hold harmless L&D Nexus Limited, its officers, directors, and employees from any claims, damages, or expenses arising from your use of the website or violation of these Terms.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">11. Third-Party Links</h2>
            <p>Our website may contain links to third-party websites (e.g., LinkedIn, Calendly). We are not responsible for the content, privacy practices, or terms of any third-party websites.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">12. Changes to Terms</h2>
            <p>We may update these Terms from time to time. The "Last updated" date at the top of this page indicates when these Terms were last revised. Continued use of the website after changes constitutes acceptance of the updated Terms.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#1A1A1A] mb-3">13. Governing Law</h2>
            <p>These Terms are governed by the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.</p>
            <p className="mt-3">For questions about these Terms, contact us at <a href="mailto:office@magnuskor.com" className="text-[#B8860B] hover:underline">office@magnuskor.com</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
